import { z } from 'zod';
import { createKeyRecordSchema } from '../KeyRecordSchemas.ts';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from '../PartialStrictObjectSchema.ts';
import { validateState } from '../ValidateState.ts';
import { EnumUtils } from '@colonist/utils';
import { PlayerColor } from '../PlayerState.ts';
const mechanicSettlementPlayerStateSchema = z.object({
    bankSettlementAmount: z.number().int().nonnegative()
}).strict();
const playerColorNumericKeys = EnumUtils.getEnumValues(PlayerColor);
export const mechanicSettlementStateSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicSettlementPlayerStateSchema);
export function validateMechanicSettlementState(data) {
    return validateState(mechanicSettlementStateSchema, data);
}
const mechanicSettlementPlayerStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(mechanicSettlementPlayerStateSchema);
export const mechanicSettlementStatePartialSchema = createKeyRecordSchema(playerColorNumericKeys, mechanicSettlementPlayerStatePartialSchema, {
    requireAtLeastOneEntry: true
});
